import React from 'react';
import { Transfer } from 'antd';

export const LCTransfer = props  => (
  <Transfer {...props}/>
);
